import { createTRPCReact } from '@trpc/react-query'
import type { AppRouter } from '@warike/api'

/** Typed tRPC hooks. The `AppRouter` type is erased at build time — no runtime
 * dependency on the server package ships to the browser. */
export const trpc = createTRPCReact<AppRouter>()
